module.exports = __webpack_public_path__ + "39b5ff14.otf";